{
  "cancel": "Cancel",
  "save": "Save",
  "manage": "Manage",
  "create": "Create",
  "delete": "Delete",
  "new": "New",
  "event_nav_title": "Navigation",
  "event_module_name_basic": "Basic",
  "event_module_name_sales": "Sales",
  "perc": "%",
  "currency": "€",
  "event_manage": "Event details",
  "event_manage_products": "Products",
  "event_manage_status": "Status",
  "event_manage_minimum_age": "Event name",
  "event_manage_minimum_age_info": "Leave empty if there is no minimum age",
  "event_manage_name": "Event name",
  "event_product_title": "Manage event products",
  "event_product_saved": "Product details updated!",
  "event_product_add": "Add product",
  "product_name": "Product name",
  "product_modal_edit": "Edit product",
  "product_modal_create": "Create product",
  "product_saved": "Product updated!",
  "product_group": "Group",
  "product_status": "Status",
  "nav_dashboard": "Dashboard",
  "nav_companies": "Manage Companies",
  "nav_events": "My events",
  "nav_company": "My company",
  "nav_discountcodes": "Discountcodes",
  "nav_orders": "Orders",
  "nav_reports": "Reports",
  "nav_scan_operations": "Scan operations",
  "nav_administration": "Administration",
  "nav_extensions": "Extensions",
  "app_logout": "Logout",
  "app_impersonating": "You are impersonating {name}. Click logout to go back to your own admin role",
  "login_email": "E-mail",
  "login_password": "Password",
  "login_button": "Login",
  "login_error": "Login failed, please try again",
  "events_title": "Manage events",
  "event_create": "Create new event",
  "event_new_modal_title": "Create an event",
  "event_name": "Event name",
  "event_create_hint": "Once you have created the event, you can set more options if desired.",
  "event_nav_manage": "Event details",
  "event_nav_products": "Products / Tickets",
  "event_nav_pos": "Points of sale",
  "event_nav_timeslots": "Timeslots",
  "event_manage_title": "Manage your event: {name}",
  "event_minimum_age": "Minimum age",
  "event_status": "Status",
  "event_starts_at": "Event starts at",
  "event_ends_at": "Event ends at",
  "event_description": "Event description",
  "company_manage_title": "Manage company {name}",
  "company_users": "Company users",
  "company_details": "Company details",
  "company_subdomain": "Subdomain",
  "company_contact": "Person of contact",
  "company_phone": "Phone number",
  "company_address": "Address",
  "company_zip": "ZIP",
  "company_city": "City",
  "company_kvk": "KVK number",
  "company_vat": "VAT number",
  "company_ticket_fee": "Fee per ticket",
  "company_paynl_service_id": "Pay.nl service id",
  "company_paynl_api_token": "Pay.nl API token",
  "company_paynl_token_code": "Pay.nl API code",
  "company_country": "Country",
  "company_user_impersonate": "Impersonate",
  "user_create": "Add a new user",
  "user_language": "Language",
  "user_create_modal_title": "Add new user to {name}",
  "user_name": "Name",
  "user_email": "e-mail address",
  "user_password": "Password",
  "edit_user_modal_title": "Edit user details",
  "user_password_hint": "Leave this field empty if you do not wish to change the password",
  "content_top_welcome_message": "Welcome to {whitelabel_layout_name}",
  "event_pos_title": "Event points of sale",
  "event_pos_create": "Add",
  "pos_modal_create": "Create a new point of sale",
  "pos_name": "Name",
  "pos_language": "Language",
  "pos_url": "URL",
  "pos_modal_edit": "Edit POS",
  "lang_en": "English",
  "lang_nl": "Dutch",
  "lang_de": "German",
  "lang_es": "Spanish",
  "event_timeslots": "Timeslots",
  "event_timeslot_title": "Manage your timeslots: {name}",
  "timeslot_add": "Add a new timeslot",
  "timeslot_modal_edit": "Edit timeslot",
  "timeslot_modal_create": "Create a new timeslot",
  "timeslot_interval": "Interval",
  "timeslot_amount": "Amount",
  "interval_hourly": "Hourly",
  "timeslot_start": "Timeslot start",
  "timeslot_end": "Timeslot end",
  "timeslot_starts_at": "Start",
  "timeslot_ends_at": "End",
  "timeslot_date": "Date",
  "timeslot_saved": "Timeslot saved!",
  "timeslot_created": "Timeslot created!",
  "pos_modal_edit_products": "Products in stock for this point of sale",
  "pos_products_hint": "Leave stocks empty if you don't want to offer this product at this point of sale",
  "pos_payment_methods": "Payment Methods",
  "payment_method": "Payment method",
  "pos_open": "Buy tickets",
  "pos_event_open": "Open",
  "pos_payment_method_fee_percentage": "Administration costs (percentage)",
  "pos_payment_method_fee_fixed": "Administration costs (amount)",
  "pos_updated": "Point of Sale updated!",
  "companies_title": "Manage companies",
  "companies_create": "Add new company",
  "view_pos_minimum_age": "The minimum age for this event is {minimum_age}",
  "view_pos_buy": "Buy now!",
  "pos_product_sold_out": "Sold-out",
  "cart_title": "Order summary",
  "cart_total": "Total",
  "cart_order": "Continue",
  "cart_sub_total": "Sub-total",
  "cart_ticket_fee": "Administration costs",
  "cart_empty": "Your cart is currently empty, please add some products",
  "cart_button_hint": "We check the availability of your choice upon clicking on Place order",
  "customer_company_name": "Company name",
  "customer_first_name": "First name",
  "customer_last_name": "Last name",
  "customer_address": "Full address",
  "customer_zip": "ZIP code",
  "customer_city": "City",
  "customer_phone": "Phone number",
  "customer_email": "Email address",
  "customer_dob": "Date of birth",
  "customer_gender": "Gender",
  "customer_gender_male": "Male",
  "customer_gender_female": "Female",
  "customer_personal_info": "Personal details",
  "customer_contact_info": "Contact information",
  "order_payment_method": "Select a payment method",
  "cart_payment_fee": "Payment fee",
  "order_continue": "Place order",
  "payment_bank": "Choose your bank",
  "payment_loading": "Loading payment...",
  "payment_failed": "Payment failed!",
  "payment_complete": "Payment successful! You will receive your order confirmation in your inbox!",
  "event_nav_customer_information": "Customer information",
  "event_customerinformation_title": "Manage your customer information",
  "question_add": "Add a new question",
  "textfield": "Textfield",
  "select_box": "Dropdown box",
  "radio_buttons": "Radio buttons",
  "checkboxes": "Checkboxes",
  "customer_information_modal_create": "Add a question",
  "customer_information_question": "What is your question",
  "customer_information_question_type": "Question type",
  "customer_information_mandatory": "Mandatory",
  "customer_information_where_to_show": "Where would you like to ask this question",
  "customer_information_show_order": "Order level",
  "customer_information_show_products": "Product level",
  "customer_information_modal_edit": "Edit question: {question}",
  "customer_information_which_products": "Select the product(s) at which you would like to show the question",
  "customer_information_new_answer": "New answer...",
  "customer_information_saved": "Questions saved!",
  "company_name": "Company name",
  "first_name": "First name",
  "last_name": "Last name",
  "address": "Address",
  "zip": "ZIP",
  "email": "Email",
  "city": "City",
  "country": "Country",
  "dob": "Date of birth",
  "mobile": "Mobile",
  "gender": "Gender",
  "customer_information_title_general_questions": "General questions upon ordering",
  "customer_information_title_specific_questions": "Specific questions",
  "dashboard_title": "Welcome!",
  "pos_not_live": "This point of sale is currently closed, try again later",
  "order_loading": "Loading your order",
  "event_charge_ticket_fee": "Charge processing fee per ticket on customers",
  "pos_not_found": "Point of sale not found, please check your link",
  "order_not_found_or_expired": "Order not found or expired",
  "event_continuous": "This event is continuous",
  "discountcode_new_modal_title": "Add a new discountcode",
  "discountcode_code": "Discountcode",
  "discountcode_create_hint": "Once you've created your discountcode, you are able to set more detailed information!",
  "discountcode_modal_edit": "Edit discountcode: {code}",
  "discountcode_type": "Type",
  "discountcode_type_percentage": "Percentage",
  "discountcode_type_value": "Value",
  "discountcode_amount": "Amount",
  "discountcode_stock": "Stock",
  "discountcode_is_active": "Is active",
  "discountcode_saved": "Discountcode saved!",
  "discountcode_starts_at": "Starts at",
  "discountcode_ends_at": "Ends at",
  "pos_custom_css": "Custom CSS",
  "order_id": "Order ID",
  "order_full_name": "Customer name",
  "order_event": "Event",
  "order_created_at": "Created at",
  "order_is_paid": "Paid?",
  "order_details": "Details",
  "order_products": "Ordered products",
  "order_customer_details": "Customer details",
  "order_paid": "Order is paid!",
  "order_not_paid": "Order NOT Paid!",
  "order_total": "Order total",
  "order_payment_created_at": "Created at",
  "order_payment_status": "Status",
  "order_payment_amount": "Payment",
  "nav_scanners": "Scan center",
  "scanner_add_modal_title": "Add a new scanner",
  "scanner_name": "Scanner name",
  "scanner_create_hint": "Use a descriptive name for your scanner. A password and login will be generated automatically",
  "scanner_show_login_qr": "Show Login QR Code",
  "scanner_qr_code": "Scan this QR code on the mobile app",
  "close": "Close",
  "scanner_edit": "Edit Scanner",
  "scanner_updated": "Scanner is updated!",
  "pos_no_group": "Tickets without group",
  "order_notes": "Notes",
  "ticket_not_generated": "Ticket not generated!",
  "ticket_generated": "Generated",
  "ticked_scanned": "Scanned",
  "ticket_view": "View ticket",
  "ticket_generate": "Generate new ticket",
  "order_create_note": "Create new note",
  "order_expires_in": "If you do not complete your order in time, it will automatically be canceled. You have {timeLeft} to complete your order",
  "ticket_not_found": "Ticket not found",
  "order_no_payment_method": "No payment method selected",
  "payment_successful": "Payment successful!",
  "unknown": "Unknown",
  "email_order_confirmation": "Order confirmation sent",
  "audit_show_context": "Show details",
  "email_content": "Email contents",
  "email_ticket_sent": "Ticket sent via email",
  "assign_tickets_title": "Who should receive the tickets?",
  "assign_tickets_hint": "We've received your order and your payment is completed! The only thing you need to do before you can enjoy the event is assigning your tickets",
  "assign_tickets_send": "Assign",
  "assign_ticket_self": "enter myself",
  "assign_ticket_sent": "send invite",
  "ticket_claim": "Claim ticket",
  "customer_full_name": "Full name",
  "customer_form_title": "Please enter your personal details",
  "error_try_again": "An error occurred, please try again",
  "error_select_payment_method": "Select a payment method",
  "product_type": "Product type",
  "product_is_upsell": "Upsell product without E-ticket",
  "product_is_not_upsell": "E-Ticket",
  "product_price": "Price",
  "product_stock": "Capacity",
  "product_specific_sale_times": "Specific sale time",
  "product_no_products": "No products have yet been added",
  "discountcode_add_to_cart": "Add discount code",
  "discount_code_claim": "Claim",
  "discountcode_invalid": "This discount code is invalid.",
  "cart_discount": "Discount {code}",
  "event_module_name_marketing": "Marketing",
  "event_module_name_organise": "Organise",
  "event_print_visitor_list": "Visitor list",
  "print": "Print",
  "order_pick_timeslot": "Pick your timeslot",
  "email_ticket_assigned": "email ticket assigned",
  "order_actions": "Actions",
  "order_cancel": "Cancel order",
  "order_refund": "Refund order",
  "order_is_cancelled": "This order is cancelled!",
  "order_cancelled": "Order is cancelled",
  "order_log": "Log",
  "order_is_refunded": "Order refunded",
  "user_added": "User added!",
  "company_updated": "Company details updated!",
  "user_role": "role",
  "user_updated": "User details updated!",
  "login_invalid": "Invalid login, please try again",
  "no_product_group": "Products without group",
  "pos_status": "Status",
  "pos_no_product_category": "Products without category",
  "company_invoice_prefix": "Invoice prefix",
  "yes": "Yes",
  "no": "No",
  "order_number": "Order number",
  "order_resend_confirmation": "Re-send tickets",
  "optin": "Opt-in email updates",
  "customer_optin": "I would like to receive information from this organiser",
  "customer_optin_iams": "Yes, I would like to receive emails from IAMS for a chance to win cool prizes & VIP Experiences",
  "shop_questions_event_hint": "Our customer service is always there for you. Just write an email or call the following number!",
  "shop_questions_tickets_hint": "If you have any questions, you can always contact Fairtix. Just write an email or call the following number!",
  "shop_questions_event": "Questions about the event?",
  "shop_questions_tickets": "Questions about tickets?",
  "order_expired": "Your order has expired, please start over",
  "layout_settings": "Layout settings",
  "layout_primary_color": "Primary color",
  "layout_secondary_color": "Secondary color",
  "layout_secondary_backgroundColor": "Primary background color",
  "layout_colors": "Layout colors",
  "layout_header": "Header",
  "layout_logo": "Logo",
  "layout_header_backgroundColor": "Header background color",
  "company_layout": "Layout settings",
  "add": "Add",
  "layout_updated": "Layout updated!",
  "shop_tickets": "Tickets",
  "shop_personal_details": "Personal details",
  "shop_additional_products": "Extra products",
  "shop_timeslot": "Timeslot",
  "shop_pay": "Payment",
  "cart_clear": "Clear cart",
  "invalid_discount_code": "Invalid discount code",
  "access_denied": "access denied",
  "discountcode_already_exists": "This discountcode already exists.",
  "end_before_start_date": "End date cannot be before start date",
  "scanner_token_invalid": "Token for scanner is invalid",
  "ticket_invalid": "Ticket is invalid",
  "ticket_change_owner": "Change owner",
  "product_max_exceeded": "Too many products in order, the amount is above the product limit per order",
  "order_not_paid_error": "Cannot complete action, order is not paid",
  "product_not_live": "Product is not live",
  "product_not_upsell": "Cannot add product order. It is not an additional product",
  "product_out_of_stock": "Product is out of stock",
  "product_create_eticket": "Do you want to generate an e-ticket?",
  "product_is_cross_sell": "Show as cross-sell item",
  "product_multi_day_ticket": "Multi-day ticket",
  "product_multi_day_ticket_tooltip": "When checking this checkbox this ticket gets reset automatically every night. Meaning the ticket will be allowed to be scanned again the next day. This must be used for example for weekend tickets.",
  "product_stock_unlimited_icon": "∞",
  "product_stock_unlimited_text": "Unlimited",
  "product_not_unlimited_stock": "product is not unlimited on stock",
  "ticket_already_scanned": "Ticket is already scanned",
  "invalid_ticket_entrance": "Invalid entrance for ticket",
  "timeslot_event_time_mismatch": "Timeslot is not in event start / end range",
  "timeslot_overlap": "You cannot create overlapping timeslots",
  "token_expired": "Session expired, please login",
  "timeslot_too_many_spots": "Cannot create timeslot: There are not enough products for this amount",
  "assign_tickets_select": "Which tickets would you like to send?",
  "assign_tickets_myself": "Assign myself",
  "assign_tickets_by_invite": "Send invites",
  "assign_tickets_continue": "Send and continue",
  "tickets_fill_completed": "Tickets completed",
  "tickets_fill_title": "Complete your tickets ({todo}/{done})",
  "phone": "Phone number",
  "customer_fields_saved": "Customer fields saved",
  "customer_country": "Country",
  "customer_house_nr": "House no",
  "country_de": "Germany",
  "country_nl": "Netherlands",
  "country_es": "Spanish",
  "country_be": "Belgium",
  "customer_form_custom_questions": "Please answer the following questions",
  "errors_please_select": "Please select an option",
  "order_thank_you": "Thank you for your order #{order_number}",
  "order_thank_you_text": "Your order is now completed.",
  "order_thank_you_btn_ticket_download": "Download tickets",
  "assign_tickets_next": "Next",
  "order_status_number": "Your order #{order_number}",
  "order_status_event": "Event: {name}",
  "order_status_paid": "Paid",
  "order_status_ticket_not_assigned": "Not yet registered to name",
  "order_status_put_on_name": "Assign name",
  "order_status_product_refunded": "Refunded at {refunded_at}",
  "order_status_product_cancelled": "Cancelled",
  "order_status_product_invited_at": "Invited at{invited_at}",
  "order_status_ticket_generating": "Ticket is being generated",
  "order_status_alert_refunded": "Your order has been refunded",
  "order_status_alert_cancelled": "Your order has been cancelled",
  "order_status_alert_not_paid": "Your payment did not go through or was not accepted by our payment service provider, please place a new order.",
  "order_status_alert_pending": "Your payment has not yet gone through, our payment service provider will check this payment manually. This may take several hours.",
  "ticket_reminded_at": "Reminded at",
  "ticket_invited_at": "Invited at",
  "ticket_claimed_at": "Claimed at",
  "ticket_not_claimed": "Ticket not claimed",
  "ticket_download": "Download ticket",
  "ticket_send_reminder": "Send reminder",
  "ticket_reminder_sent": "Reminder sent!",
  "customer_email_suggestion": "Did you mean {full}?",
  "order_status_your_tickets": "Your tickets",
  "order_open_customer_status": "Open customer status page",
  "ticket_change": "Change",
  "cart_terms_conditions_first": "I agree with the",
  "cart_terms_conditions": "When clicking the 'Continue' button you confirm that you read and agree with the <a href='{url}' target='_blank'>Terms & Conditions</a> & <a href='https://fairtix.io/en/privacy-policy' target='_blank'>Privacy Policy</a> of Fairtix",
  "must_agree_with_tos": "You must agree with the Terms & Conditions in order to continue.",
  "product_max_buy": "Maximum buy per order",
  "product_description": "Description",
  "actions": "Actions",
  "product_vat_percentage": "VAT %",
  "product_image": "Image",
  "template_qr": "QR Code position",
  "top": "Top",
  "left": "Left",
  "width": "Width",
  "height": "height",
  "template_texts": "Text elements",
  "template_texts_hint": "You can place multiple pieces of text",
  "template_add_text": "Add text block",
  "template_background": "Background image",
  "template_save": "Save template",
  "generate_preview": "Download preview",
  "nav_ticket_templates": "Ticket templates",
  "ticket_template_background": "Ticket background",
  "template_background_hint": "The file you upload should have 1240x1755 in pixels, at 72DPI",
  "customer_gender_other": "other",
  "ticket_template_updated": "Ticket template updated!",
  "template_text_block": "Text",
  "template_position_hints": "The page has 595 by 842 'points', anything out of this range wont be shown on the ticket",
  "ticket_template_name": "Template name",
  "error_name": "Invalid name",
  "event_ticket_template": "Ticket template",
  "event_has_donation_product": "Event can not have more than one Donation product",
  "whatsapp_message": "Please claim your ticket for {event} here: {link}",
  "event_updated": "Event details updated!",
  "event_not_live": "The event is not open for sales at this time, try again later",
  "event_is_archived": "The event has been archived and can not be edited anymore",
  "event_passed": "The event is not live",
  "product_sale_starts_at": "Sale starts at",
  "product_sale_ends_at": "Sale ends at",
  "error_page_not_found": "Page not found",
  "create_template": "Create template",
  "template_modal_create": "Create a new template",
  "template_name": "Name",
  "error_is_upsell": "Choose your product type",
  "error_vat_percentage": "Fill in a VAT percentage",
  "error_price": "Fill in a price",
  "error_stock": "Fill in a stock amount",
  "error_status": "Choose a status",
  "ticket_confirmation_resent": "Ticket confirmation is resent!",
  "layout_cart": "Cart layout",
  "layout_cart_backgroundcolor": "Background color",
  "layout_cart_color": "Text color",
  "layout_cart_product_title_color": "Product title color",
  "layout_cart_product_subtext_color": "product subtext color",
  "layout_cart_product_price_color": "Product price color",
  "layout_cart_button_backgroundColor": "Button background color",
  "layout_cart_button_color": "Button color",
  "layout_cart_sidebar": "Cart sidebar",
  "layout_cart_sidebar_backgroundColor": "Background color",
  "layout_cart_sidebar_color": "Text color",
  "layout_cart_sidebar_button_backgroundColor": "Button background color",
  "layout_cart_sidebar_button_color": "Button text color",
  "layout_cart_product_group_backgroundColor": "Group background color",
  "layout_cart_product_group_textColor": "Group text color",
  "layout_top_bar": "Top bar layout",
  "layout_top_bar_title_color": "Title color",
  "layout_stepper_backgroundColor": "Stepper background color",
  "layout_stepper_color": "Stepper text color",
  "layout_info_blocks": "Info blocks layout",
  "layout_info_blocks_titleColor": "Title color",
  "layout_info_blocks_color": "Text color",
  "layout_info_blocks_backgroundColor": "Background",
  "layout_stepper_done_backgroundColor": "Stepper done background color",
  "layout_stepper_done_color": "Stepper done text color",
  "view_pos_title": "Product overview for {event_name}",
  "pos_personal_details_title": "Personal details",
  "pos_timeslot_title": "Timeslot overview",
  "pos_allow_donation_question": "Allow donations?",
  "pos_payment_method_title": "Payment methods",
  "order_view_order_details_title": "Assign your ticket(s)",
  "order_view_assign_title": "Assign your ticket(s)",
  "order_thank_you_title": "Thank You",
  "order_status_title": "Order overview",
  "ticket_changed": "Ticket changed!",
  "ticket_changed_text": "The ticket has been changed and will be emailed shortly. ",
  "view_pos_cart_title": "Tickets",
  "tickets_assigned_email_sent": "Invite email successfully sent!",
  "backend_title_login": "Fairtix Controle Panel",
  "backend_title_dashboard": "Dashboard",
  "backend_title_order_overview": "Order overview",
  "backend_title_order_detail": "Order detail {order_number}",
  "backend_title_events_overview": "Events overview",
  "backend_title_events_manage": "Manage event",
  "backend_title_events_products": "Event products",
  "backend_title_events_timeslots": "Event timeslots",
  "backend_title_events_customer_information": "Event customer information",
  "backend_title_events_pos": "Event points of sales",
  "backend_title_events_visitor_list": "Event visitor list",
  "backend_title_reports": "Reports",
  "backend_title_discountcodes": "Discountcodes overview",
  "backend_title_ticket_templates": "Ticket templates",
  "backend_title_edit_ticket_templates": "Edit ticket template",
  "backend_title_manage_company": "Manage company",
  "report_genders_unkown": "Unkown",
  "report_genders_f": "Women",
  "report_genders_m": "Men",
  "report_genders_o": "Other",
  "report_cities_unkown": "Unkown",
  "report_paid_orders": "Paid orders",
  "report_tickets_sold": "Tickets given out",
  "report_tickets_claimed": "Tickets claimed",
  "report_total_revenue": "Total revenue",
  "report_sales_per_day": "Sales per day",
  "report_sales_per_day_cumulative": "Sales cumulative",
  "report_tickets_sold_per_type": "Tickets sold per type",
  "report_gender": "Genders",
  "report_cities": "Cities",
  "report_payment_methods": "Payment methods",
  "report_tickets": "Tickets",
  "report_age": "Ages",
  "report_event": "Event",
  "report_date_range_start": "Date start",
  "report_date_range_end": "Date end",
  "report_filter_btn": "Filter",
  "ticket_templates": "Ticket templates",
  "ticket_customer_not_set": "Customer not found",
  "order_payment_pending": "When your payment is received, we will send you an email with a link to claim your tickets.",
  "export_orders": "Export orders",
  "language_en": "English",
  "language_de": "German",
  "language_nl": "Dutch",
  "orders_export": "Export orders to CSV",
  "export_event_name": "Event name",
  "export_order_number": "Order number",
  "export_total_price": "Total price",
  "export_discount": "Discount",
  "export_order_payment_fee": "Payment administration costs",
  "export_order_payment_fee_vat": "Payment administration costs VAT",
  "export_order_payment_fee_vat_perc": "Payment administration costs VAT %",
  "export_ticket_fee_total": "Ticket administration costs",
  "export_ticket_fee_vat": "Ticket administration costs VAT",
  "export_ticket_fee_vat_perc": "Ticket administration costs VAT %",
  "export_product_number": "Product number",
  "export_product_price": "Product price",
  "export_product_price_vat": "Product price VAT",
  "export_product_price_vat_perc": "Product price VAT %",
  "export_product_service_fee": "Product service administration costs",
  "export_product_service_fee_vat": "Product service administration costs VAT",
  "export_product_service_fee_vat_perc": "Product service administration costs BTW %",
  "export_order_payment_method": "Payment method",
  "export_customer_first_name": "Customer first name",
  "export_customer_last_name": "Customer last name",
  "export_customer_company_name": "Customer company name",
  "export_customer_email": "Customer email",
  "export_customer_address": "Customer address",
  "export_customer_zip": "Customer ZIP",
  "export_customer_city": "Customer city",
  "export_customer_country": "Customer country",
  "export_customer_gender": "Customer gender",
  "export_customer_optin": "Customer optin",
  "export_customer_phone": "Customer phone",
  "export_product_id": "Product id",
  "export_product_group": "Product group",
  "export_product_name": "Product name",
  "export_product_type": "Product type",
  "export_settings_from": "Start date",
  "export_settings_to": "End date",
  "export_settings_fields": "Fields to export",
  "export_settings_check_all": "Select all fields",
  "orders_export_make": "Make export",
  "error_from": "No start date selected",
  "error_to": "No end date selected",
  "error_fields": "No fields selected",
  "timeslot_deleted": "Timeslot deleted!",
  "timeslot_already_in_orders": "Cannot delete timeslot, it has already been ordered",
  "cart_vat": "VAT",
  "cart_product": "Product",
  "cart_price": "Amount",
  "company_vat_percentage": "Company default VAT",
  "max": "Max",
  "not_set": "Not set",
  "template_title": "Edit template: {name}",
  "order_discount": "Discount",
  "ticket_cancelled": "Cancelled",
  "order_status_cancelled": "Cancelled",
  "order_status_refunded": "Refunded",
  "ticket_cancel": "Cancel",
  "order_detail_ticket_cancelled": "Ticket cancelled successfully",
  "order_detail_modal_cancel_order_title": "Cancel order: #{order}",
  "order_detail_order_cancelled": "Order cancelled",
  "order_detail_cancel_order": "Cancel order",
  "order_detail_cancel_order_confirmation": "Are you sure you want to cancel this order?",
  "order_detail_modal_refund_order_title": "Refund order: #{order}",
  "order_detail_refund_order_confirmation": "Are you sure you want to refund this order?",
  "order_detail_refund_order": "Refund",
  "order_detail_refund_order_amount": "Amount",
  "order_detail_refund_greater_error": "Amount should not be greater than: ",
  "order_detail_refund_less_error": "Amount should be positive",
  "order_detail_order_refunded": "Order has been refunded successfully",
  "order_refund_invalid_amount_error": "Invalid amount",
  "order_detail_modal_resent_tickets_title": "Send tickets again: #{order}",
  "order_detail_resent_tickets_confirmation": "Are you sure you want to send the tickets again?",
  "order_detail_resent_confirmation_tickets": "Send tickets",
  "payment_started": "Payment started",
  "order_refunded": "Order refunded",
  "order_detail_modal_send_mail": "Inform the customer with an email",
  "order_detail_mail_receiver": "Receiver",
  "order_detail_mail_subject": "Subject",
  "order_detail_mail_message": "Message",
  "mail_subject_cancel_order": "{first_name}, your order has been cancelled",
  "email_order_cancelled": "Order cancelled",
  "mail_subject_refund_order": "{first_name}, your order has been refunded",
  "email_order_refunded": "Order refunded",
  "order_customer_answers": "Customer answers",
  "delete_entry": "Are you sure you want to delete this record?",
  "opening_hours_all_day": "all day",
  "opening_hours_hourly": "hourly",
  "product_had_been_ordered": "The product had been ordered",
  "product_modal_delete": "Delete product",
  "product_delete_confirmation": "Are you sure you want to delete this product?",
  "product_has_been_deleted": "Product has been deleted",
  "event_event_type": "Event Type",
  "user_role_user": "User",
  "user_role_company_admin": "Company admin",
  "order_detail_payment_method": "Payment method",
  "pos_in_test_mode": "This Point of Sale is in TEST mode",
  "order_test_paid": "Test order",
  "product_successfully_ordered": "Success",
  "manage_company_without_vat": "These prices are without VAT",
  "product_calculate_service_fee": "Pass administration costs to the customer",
  "product_companies_ticket_fee": "Your companies ticket fee is €{ticket_fee_incl} incl VAT",
  "order_overview_show_expired": "Show expired orders",
  "scan_operation_manage": "Manage",
  "scan_operation_add_modal_title": "Make scan operation",
  "scan_operation_create_hint": "Choose the event that you are will to make a scan operation for",
  "select_event": "Event",
  "scan_test_mode": "Test mode",
  "scan_test_mode_hint": "Enable test mode",
  "scan_enable_outgoing": "Enable outgoing scans",
  "scan_enable_outgoing_hint": "Scan visitors when they leave",
  "scan_sessions": "Scan sessions",
  "scan_start_date": "Start",
  "scan_start_time": "Start",
  "scan_end_date": "End",
  "scan_end_time": "End",
  "scan_operation_session_name": "Session name",
  "scan_operation_sessions_dates": "Dates",
  "scanner_modal_delete": "Delete Scanner",
  "scanner_has_been_deleted": "Scanner has been deleted!",
  "scanner_modal_edit": "Edit scanner details",
  "scanner_username": "Username",
  "scanner_password": "Password",
  "scanner_description": "Description (e.g.: Main enterance)",
  "scan_operation_session_modal_edit": "Edit session details",
  "scan_operation_updated": "Scan operation has been updated",
  "scan_name": "Scan name",
  "scanner_manage_title": "Manage the scanner details",
  "scan_operation_session_configure_products": "Configure Products",
  "scan_operation_session_product_saved": "Product has been synced with session successfully",
  "scan_operation_session_product_deleted": "Product have been un synced with session successfully",
  "scan_operation_session_modal_delete": "Delete session confirmation",
  "sessions": "Sessions",
  "scan_operation_session_configure_scanners": "Configure Scanners",
  "scan_operation_session_configure_scanners_duplicated": "Cannot duplicate session/product for same scanner",
  "session_has_been_deleted": "Session has been deleted!",
  "scan_operation_overview_for": "Scan operation overview for: {event_name}",
  "scan_operation_overview_event": "Event: {event_name}",
  "scan_operation_overview_outgoing_scans": "Outgoing scans:",
  "scan_operation_overview_outgoing_test_mode": "Test mode:",
  "scan_operation_overview_outgoing_enabled": "Enabled",
  "scan_operation_overview_outgoing_disabled": "Disabled",
  "scan_operation_overview_outgoing_false": "False",
  "scan_operation_overview_outgoing_true": "True",
  "scan_operation_overview_scanners": "Scanners",
  "scan_operation_overview_sessions": "Sessions",
  "scan_operation_overview_edit": "Edit",
  "scan_operation_overview_product_configuration": "Product Configuration",
  "scan_operation_overview_scanner_configuration": "Scanner Configuration",
  "session_name": "Session name",
  "next": "Next",
  "previous": "Previous",
  "scan_operation_products": "Products",
  "finish": "Finish",
  "backend_title_scan_operation_manage": "Manage scan operation",
  "backend_title_scan_operation_summary": "Scan operation summary",
  "backend_title_scan_operation_product_configuration": "Product configuration",
  "backend_title_scan_operation_scanner_configuration": "Scanner configuration",
  "date_format": "dd-mm-yyyy",
  "export_no_results": "No results are found within this timeframe",
  "ticket_customer_not_assigned": "Ticketholder not assigned",
  "copy_ticket_link": "Copy link",
  "ticket_assign": "Assign ticket",
  "ticket_assigned_explenation": "{customer_first_name} has bought you a ticket for the event {event_name}. Claim your ticket by filling in the form below.",
  "scan_operation_event": "Event",
  "scan_operation_status": "Status",
  "scan_operation_users": "Amount of users",
  "scan_operation_actions": "Actions",
  "event_module_name_box_offices": "Box offices",
  "event_nav_box_offices": "Box offices",
  "event_box_office_create": "Create new box office",
  "event_box_office_create_name": "Box office name",
  "event_box_office_name": "Box offices",
  "event_box_office_modal_edit": "Edit box office",
  "event_box_office_products": "Select the products that are being showed in the box office",
  "event_box_office_payment_methods": "Select the payment methods that are being showed",
  "box_office_updated": "Box office successfully changed",
  "event_box_office_check_overrule": "Overrule price",
  "user_box_office": "Is box office",
  "box_office_choose_event_title": "Choose an event for which you want to start the Box office",
  "box_office_choose_box_office_title": "Choose the box office you want to start for the event: {event_name}",
  "box_office_place_order_price": "Price",
  "box_office_place_order_available": "Available",
  "box_office_place_order_sold_out": "Sold out",
  "box_office_place_order_save_settings_success": "Success",
  "box_office_place_order_customer_details": "Customer details",
  "box_office_place_order_fill_customer_details": "Fill in the details of the customer",
  "box_office_place_order_choose_payment": "Choose the preferred payment method",
  "box_office_place_order_payment_pin": "Pin",
  "box_office_place_order_payment_cash": "Cash",
  "box_office_place_order_discount_enter": "Enter",
  "box_office_place_order_remove_discount": "Remove discount",
  "box_office_place_order_empty_cart": "Empty cart",
  "box_office_place_order_amount_of_products": "Amount of products:",
  "box_office_place_order_subtotal": "Subtotal:",
  "box_office_place_order_total": "Total:",
  "box_office_place_order_discount": "Discount:",
  "box_office_place_order_which_product_to_show": "Which product(s) would you like to show?",
  "box_office_place_order_place_order": "Place Order",
  "event_default_group": "Default Group",
  "event_box_office_use_all_stock": "Use of stocks of unsold tickets",
  "box_office_place_paid_success": "Order paid successfully.",
  "box_office_place_order_customer_has_to_pay": "Customer has to pay",
  "box_office_place_order_given_by_customer_in": "Given by customer in",
  "box_office_place_order_return_to_customer_in": "Return to customer in",
  "box_office_order_history_order_number": "Order number",
  "box_office_order_history_order_placed": "Placed at",
  "box_office_order_history_payment_method": "Payment method",
  "box_office_order_history_customer": "Customer",
  "box_office_order_history_products": "Product(s)",
  "box_office_order_history_total_price": "Total price",
  "unkown": "Unkown",
  "add_discount": "Add discount",
  "box_office_place_save_settings_success": "Changes have been saved",
  "order_overview_box_office": "Box office",
  "order_overview_online": "Online",
  "order_type": "Order type",
  "box_office_order_history_title": "Order history",
  "box_office_place_order_discount_to_high": "Dscount can not be higher than the total amount",
  "password_is_required": "Password is required",
  "event_show_archived": "Show archived events",
  "order_overview_show_box_office_orders": "Show box office orders",
  "report_box_office": "Include box office orders",
  "export_to_email": "Export to",
  "error_email": "Email is required",
  "export_order_success": "Your download will be ready soon, link will sent to provided email",
  "role_is_required": "Role is required",
  "email_is_required": "Email is required",
  "username_is_required": "Username is required",
  "box_office_no_payment_method_chosen": "No payment method chosen",
  "box_office_no_products_chosen": "No products chosen",
  "product_remove_image": "Remove image",
  "order_ticket_scanned_at": "Scanned at",
  "order_ticket_not_yet_scanned": "Not yet scanned",
  "order_details_edit_customer_data": "Edit customer data",
  "order_details_edit_customer_success_message": "Customer data is updated",
  "customer_already_exists": "Customer already exists",
  "scan_operation_show_archived": "Show archived scan operation",
  "no_results_have_been_found": "No results have been found",
  "error_ticket_template_id": "Ticket template is not being chosen",
  "test_payment": "Test payment",
  "layout_top_bar_date_color": "Date text color",
  "layout_stepper_hint_color": "Hint text color",
  "product_show_after_expire": "Show product after time expired",
  "pos_product_expired": "Expired",
  "product_min_buy": "Minimum buy per order",
  "product_amount_is_less_than_minimum_amount": "Product amount is less than minimum amount",
  "min_buy_should_be_less_than_max_buy": "Minimum buy should be less than maximum buy",
  "dashboard_events_tickets_sold": "Tickets inclusive {guest_list_number} guest list",
  "dashboard_events_today": "Today",
  "dashboard_events_last_7_days": "Last 7 days",
  "dashboard_events_total_revenue": "Total revenue:",
  "duplicate": "Duplicate",
  "event_duplicate_event": "Duplicate event",
  "event_new_name": "New event name",
  "event_duplicate_choose_products_to_copy": "Choose which product(s) would you like to copy",
  "event_duplicate_point_of_sales": "Point of sale URLs",
  "select_all": "Select all",
  "unselect_all": "Unselect all",
  "event_scan_operation_session_date_to_change": "Scan operation session date & times have to be changed",
  "event_name_has_to_be_changed": "Event name has to be changed",
  "customer_support_free_search": "Free Search",
  "customer_support_search": "Search",
  "customer_support_reset_filter": "Reset filter",
  "customer_support_filters": "Filters",
  "customer_support_company": "Company:",
  "customer_support_event": "Event:",
  "customer_support_payment_status": "Payment status:",
  "customer_support_center": "Customer Support Center",
  "order_status_new": "New",
  "order_status_pending": "Pending",
  "user_role_customer_support": "Customer Support",
  "no_data_to_show": "No data to show",
  "submit": "Submit",
  "pos_show_in_overview": "Show point of sale in event overview",
  "login_username": "Username",
  "scan_operation_terminal_button": "Scan terminal",
  "scanner_terminal_event": "Scan terminal for",
  "dashboard_events_scans": "Scans:",
  "dashboard_total_visitors_inside": "Total visitors inside",
  "dashboard_scanned": "Scanned",
  "dashboard_left_to_scan": "Left to scan",
  "dashboard_box_office_entries": "Box office entries",
  "opening_hours_create": "Add opening hour",
  "opening_hours_day_of_week": "day",
  "opening_hours_opens_at": "opens at",
  "opening_hours_closes_at": "closes at",
  "opening_hours_spots": "spots",
  "opening_hour_interval": "interval",
  "opening_hour_create": "add new",
  "edit_opening_hours_day": "Edit opening hours for day",
  "opening_hours_adjust": "Adjust day",
  "day_adjusted": "Opening hours adjusted for day",
  "event_timeslots_actions": "Actions",
  "error_opens_at": "Opens at is not filled correctly",
  "error_closes_at": "Closes at is not filled correctly",
  "error_spots": "Spots are not filled in",
  "error_interval": "Interval is not chosen",
  "order_pick_date": "Pick your date",
  "order_timeslot": "Timeslot",
  "invalid_opening_hour": "Invalid opening hour",
  "event_ticket_template_product_tooltip": "Choosing a template overrules the default ticket template configured for the event for this specific product.",
  "company_show_kvk_on_pos": "Show chamber of commerce number in shop",
  "shop_chamber_of_commerce_number": "Chamber of commerce number",
  "my_company_invoice_title": "Automatic invoice settings",
  "my_company_invoice_automatic_invoicing": "Enable automatic invoicing",
  "my_company_invoice_automatic_invoicing_test_mode": "Test mode (No actual payouts)",
  "my_company_invoice_vat_shifted": "Make invoices VAT shifted",
  "my_company_invoice_anti_dating": "Anti date Pay.nl payouts",
  "my_company_invoice_include_payout_summary": "Include payout summary report",
  "my_company_invoice_include_fairtix_invoice": "Include Fairtix invoice for customer",
  "my_company_invoice_generate_fairtix_invoice": "Generate Fairtix invoice for customer",
  "my_company_invoice_include_detailed_explanation": "Include detailed summary report",
  "my_company_invoice_generate_detailed_explanation": "Generate detailed summary report",
  "my_company_invoice_set_off_invoices": "Set off payout invoice to Fairtix invoice",
  "my_company_invoice_generate_payout_summary": "Generate payout summary report",
  "my_company_invoice_payout_frequency": "Payout frequency",
  "my_company_invoice_max_payment_period": "Max payment period (in days)",
  "my_company_invoice_payout_delay": "Delay payout after event (in days)",
  "my_company_invoice_receive_method": "Receive method",
  "event_deleted": "Event deleted!",
  "event_has_orders": "Event contains orders",
  "pos_overview_read_less": "Read less",
  "pos_overview_read_more": "Read more",
  "manage_event_image": "Image (530x340 pixels)",
  "manage_event_remove_image": "Remove image",
  "manage_event_image_tooltip": "This image will be shown in the event overview",
  "pos_sale_ends_in_days_and_hours": "Sale ends in {days} day(s) and {hours} hour(s)",
  "pos_sale_ended_at": "Sale ended at",
  "pos_sale_ends_in_hours": "Sale ends in {hours} hours",
  "ticket_claim_copy_order_data": "Copy personal data from order",
  "template_background_jpg_hint": "Only JPGs are allowed as background image",
  "company_settings": "Settings",
  "company_send_order_notifications": "Send order notifications",
  "company_send_order_notifications_email": "Email address would like receive notifications",
  "reports_include_archived_events": "Include archived events",
  "pos_sale_ends_in_minutes": "Sale ends in {minutes} minute(s)",
  "pos_sale_ends_in_months_days_and_hours": "Sale ends in {months} month(s), {days} day(s) and {hours} hour(s)",
  "pos_sale_ends_in_months_days": "Sale ends in {months} month(s) and {days} day(s)",
  "pos_sale_ends_in_months": "Sale ends in {months} month(s)",
  "dashboard_sold_tickets": "Sold tickets for: {event}",
  "add_attendees": "Add attendees",
  "guest_list_add_attendees": "Send guest list tickets",
  "guest_list_choose_tickets": "Choose the ticket(s)",
  "guest_list_total_worth": "Total worth:",
  "guest_list_total_items": "Total Items:",
  "guest_list_order_data": "Order data",
  "quest_list_populate_tickets_with_customer_data": "Populate tickets with customer data",
  "guest_list_todo_next_send_invite_to_claim_tickets": "Send invite to claim tickets",
  "guest_list_todo_next_send_invite_to_claim_tickets_description": "The order owner will receive an email with a link where all tickets can be assigned and claimed",
  "guest_list_todo_next_send_all_tickets_to_order_owner": "Send all tickets to order owner",
  "guest_list_todo_next_send_all_tickets_to_order_owner_description": "The order owner will receive an email in which all tickets are attached as separate PDFs",
  "guest_list_todo_next_place_order_without_sending_tickets": "Place order without sending tickets",
  "guest_list_todo_next_place_order_without_sending_tickets_description": "The order will be placed without sending any tickets",
  "guest_list_no_payment_needed": "No payment needed",
  "guest_list_paid_with_cash": "Paid with cash",
  "guest_list_send_order_confirmation": "Send order confirmation by email",
  "guest_list_order_saved_successfully": "Tickets added successfully",
  "guest_list_order_saved_successfully_desc": "The order has been created and the tickets have been added to it. The specified person has received an email with the details.",
  "guest_list_not_all_customer_details_filled": "Not all customer details are filled in",
  "order_overview_free_tickets": "Free order",
  "order_overview_manual_orders": "Manual order",
  "place_order_without_tickets": "Placed order without send tickets",
  "guest_list_tickets_claim_invite": "Ticket claim invite sent",
  "guest_list_payment_terms": "What would you like to do with the payment?",
  "guest_list_what_next": "What would you like to do next?",
  "guest_list_order_confirmation_with_tickets_and_payment": "Order confirmation send of added customers",
  "guest_list_order_confirmation_with_tickets": "Order confirmation send of added customers",
  "guest_list_order_confirmation_with_payment": "Order confirmation send of added customers",
  "guest_list_order_confirmation": "Order confirmation send of added customers",
  "multi_tickets_created": "Tickets have been sent",
  "guest_list_send_all_tickets_to_order_owner": "Tickets have been sent to the order owner",
  "guest_list_send_tickets_to_ticket_holders": "Ticket has been sent directly to a ticket holder",
  "guest_list_todo_next_send_payment_link": "Send payment link by email",
  "guest_list_todo_next_send_payment_link_description": "The receiver will receive an email with a link to pay. Once the payment is received, the tickets will be sent.",
  "ticket_created": "Ticket has been sent",
  "event_name_64_char": "The event name cannot be any less than 4 characters or longer than 64 characters",
  "report_orders_grouped_by_tickets": "Orders grouped by number of tickets",
  "report_tickets_per_order": "Tickets per order",
  "report_number_of_orders": "Number of orders",
  "report_order_placed": "Order placed",
  "report_ticket_type": "Ticket Type",
  "report_tickets_selected": "Ticket(s) selected",
  "report_select_ticket": "Select ticket",
  "ticket_is_required": "Tickets field is required",
  "password_reset_successfully": "Password has been successfully reset",
  "password_confirmation": "Password confirmation",
  "company_user_reset_password_checkbox": "Let user reset password at login",
  "password_not_match": "Passwords not match",
  "password_reset_user_should_reset_password": "You need to reset the password",
  "ticket_secret": "Ticket secret",
  "scanner_terminal_showing_of_entries": "Showing {per_page} of {total} entries",
  "scanner_terminal_search": "Search",
  "scanner_terminal_filter_btn": "Filter",
  "scanner_terminal_btn_check_in": "Check in",
  "ticket_unclaimed_reminding": "Ticket claim reminder",
  "order_refund_choose_which_products_to_refund": "Choose which product(s) you would like to refund",
  "order_refund_include_ticket_fees": "Include ticket administration costs of {total} in refund",
  "order_refund_include_payment_fees": "Include payment administration costs of {total} in refund",
  "order_refund_total_amount": "Total amount to refund:",
  "order_refund_total_bigger_paid": "The total amount being refunded may never be bigger than the total amount paid",
  "company_refund_fee": "Fee per refund",
  "could_not_process_payment": "Could not process payment",
  "nav_master_data": "Master Data",
  "roles_roles_permissions": "Role Permissions",
  "roles_permission_roles": "Permission Roles",
  "roles_name": "Name",
  "roles_admin_only": "Admin only",
  "roles_online": "Online",
  "roles_created_by": "Created by",
  "role_saved_successfully": "Role saved successfully",
  "role_deleted_successfully": "Role deleted successfully",
  "company_permissions": "Company Permissions",
  "company_user_settings_tab": "User settings",
  "company_permissions_tab": "Permissions",
  "not_have_permission": "You don't have the permission to access this page",
  "permission_order_overview_view": "Order overview view",
  "permission_stock_report_view": "Stock report view",
  "permission_admin_company_overview_view": "Admin company overview view",
  "permission_admin_company_payment_costs_view": "Admin company payment costs view",
  "permission_admin_company_payment_costs_edit": "Admin company payment costs edit",
  "permission_admin_company_payment_costs_create": "Admin company payment costs create",
  "permission_admin_company_user_impersonate": "Admin company user impersonate",
  "permission_admin_company_details_view": "Admin company details view",
  "permission_admin_company_details_edit": "Admin company details edit",
  "permission_order_overview_export": "Order overview export",
  "permission_order_overview_search": "Order overview search",
  "permission_order_detail_view": "Order detail view",
  "permission_order_cancel": "Order cancel",
  "permission_order_refund": "Order refund",
  "permission_order_order_confirmation": "Order order confirmation",
  "permission_order_detail_product_cancel": "Order detail product cancel",
  "permission_order_detail_product_change_owner": "Order detail product change owner",
  "permission_order_detail_change_customer_details": "Order detail change customer details",
  "permission_add_attendees_view": "Add attendees view",
  "permission_event_overview_view": "Event overview view",
  "permission_event_create": "Event create",
  "permission_event_delete": "Event delete",
  "permission_event_duplicate": "Event duplicate",
  "permission_event_details_view": "Event details view",
  "permission_event_details_edit": "Event details edit",
  "permission_event_products_view": "Event products view",
  "permission_event_products_edit": "Event products edit",
  "permission_event_products_delete": "Event products delete",
  "permission_event_products_create": "Event products create",
  "permission_event_timeslot_view": "Event timeslot view",
  "permission_event_customer_information_view": "Event customer information view",
  "permission_event_customer_information_edit": "Event customer information edit",
  "permission_event_point_of_sale_view": "Event point of sale view",
  "permission_event_point_of_sale_create": "Event point of sale create",
  "permission_event_point_of_sale_edit": "Event point of sale edit",
  "permission_reports_view": "Reports view",
  "permission_reports_sales_by_tickettype_view": "Reports sales by tickettype view",
  "permission_discountcode_view": "Discountcode view",
  "permission_discountcode_create": "Discountcode create",
  "permission_discountcode_edit": "Discountcode edit",
  "permission_scan_operation_view": "Scan operation view",
  "permission_scan_operation_create": "Scan operation create",
  "permission_scan_operation_edit": "Scan operation edit",
  "permission_ticket_template_view": "Ticket template view",
  "permission_ticket_template_create": "Ticket template create",
  "permission_ticket_template_edit": "Ticket template edit",
  "permission_my_company_view": "My company view",
  "permission_my_company_user_create": "My company user create",
  "permission_my_company_user_edit": "My company user edit",
  "permission_my_company_user_delete": "My company user delete",
  "permission_my_company_layout_view": "My company layout view",
  "permission_my_company_layout_edit": "My company layout edit",
  "permission_dashboard_view": "Dashboard view",
  "permission_customer_support_view": "Customer support view",
  "permission_admin_company_permission_view": "Admin company permission view",
  "permission_admin_company_permission_edit": "Admin company permission edit",
  "permission_my_company_user_permissions_view": "My company user permissions view",
  "permission_my_company_user_permissions_edit": "My company user permissions edit",
  "permission_master_data_view": "Master data view",
  "permission_master_data_permissions_roles_view": "Master data permissions roles view",
  "permission_master_data_permissions_roles_edit": "Master data permissions roles edit",
  "permission_admin_automatic_invoicing_view": "Admin automatic invoicing view",
  "permission_no_company_privileges": "No company privileges have been set",
  "user_allowed_events": "Select specific events the user can see",
  "permission_my_company_user_box_office_edit": "My company can enable box office",
  "permission_role_templates": "Role templates",
  "permission_events_selected": "Event(s) selected",
  "permission_all_events": "All events",
  "search": "Search",
  "permission_master_data_permission_roles_create": "Master data permissions roles create",
  "permission_master_data_permissions_roles_delete": "Master data permissions roles delete",
  "permission_admin_company_add_company": "Admin company can add company",
  "permission_admin_company_automatic_invoicing_edit": "Admin automatic invoicing edit",
  "permission_admin_company_users_view": "Admin company users view",
  "permission_admin_company_users_edit": "Admin company users edit",
  "permission_admin_company_users_delete": "Admin company users delete",
  "permission_order_detail_payment_history_view": "Order detail payment history view",
  "permission_order_detail_notes_view": "Order detail notes view",
  "permission_order_detail_notes_create": "Order detail notes create",
  "permission_order_detail_log_view": "Order detail log view",
  "permission_my_company_users_view": "My company users view",
  "permission_event_visitor_list_view": "Event visitor list view",
  "event_created": "Event has been created",
  "scan_operation_created": "Scan operation has been created",
  "ticket_template_created": "Ticket template has been created",
  "permission_my_company_settings_edit": "My company settings edit",
  "permission_my_company_settings_view": "My company settings view",
  "permission_scan_terminal_view": "Scan terminal view",
  "permission_admin_company_details_page_view": "Admin company details page view",
  "event_duplicated": "Event has been duplicated",
  "admin_company_payment_costs_create": "Add payment method",
  "admin_company_add_payment_method": "Add payment method",
  "admin_company_payment_method": "Payment method",
  "admin_company_payment_method_fee_percentage": "Fee in percentage",
  "admin_company_payment_method_fee_fixed": "Fixed fee",
  "admin_company_payment_method_start_at": "Valid from",
  "error_fee_fixed_amount": "Fixed fee is mandatory",
  "error_fee_percentage": "Fee percentage is mandatory",
  "admin_company_payment_method_added": "Payment method added",
  "my_company_layout_remove_image": "Remove image",
  "my_company_invoice_language": "What language should the invoice be in?",
  "permission_discountcode_delete": "Discountcode delete",
  "discountcode_deleted": "Discountcode deleted",
  "discountcode_is_used": "Discount code has already been used and therefore cannot be removed",
  "order_details_change_order_event": "Move order to different event",
  "order_details_event_changed_message": "Order has successfully moved to a different event",
  "permission_order_detail_change_event": "Move orders to other events",
  "pos_payment_method_not_exists": "Point of sale payment method not exists",
  "order_details_change_event_modal_products_title": "Choose the new products",
  "order_details_change_event_modal_event": "Choose the event you want to switch the order to",
  "order_details_change_event_modal_pos": "Choose the point of sale you want to switch the order to",
  "permission_admin_company_fee_view": "Admin company fee view",
  "permission_admin_company_fee_edit": "Admin company fee edit",
  "permission_admin_company_fee_add": "Admin company fee add",
  "admin_company_add_company_fee": "Add company fee",
  "admin_company_fee_type": "Fee type",
  "admin_company_fee": "Fee",
  "admin_company_fee_start_at": "Starts at",
  "admin_company_company_fee_updated": "Company fee updated",
  "admin_company_company_fee_added": "Company fee added",
  "admin_company_company_fee_ticket_fee": "Ticket fee",
  "admin_company_company_fee_box_office_ticket_fee": "Box-office ticket fee",
  "admin_company_company_fee_refund_fee": "Refund fee",
  "admin_company_company_fee_free_tickets_free_percentage": "Free tickets free percentage",
  "admin_company_company_fee_free_ticketfee": "Free ticketfee",
  "update": "Update",
  "administration_overview_invoice": "Invoice overview",
  "backend_title_invoices_overview": "Invoices overview",
  "permission_admin_administration_view": "Administration view",
  "permission_invoice_details_view": "Invoice details view",
  "permission_invoice_overview_search": "Invoice details search",
  "permission_invoice_overview_view": "Invoice overview view",
  "permission_order_detail_generate_ticket": "Order detail generate new ticket",
  "permission_invoice_details_create_credit_invoice": "Invoice details create credit invoice",
  "invoice_details_create_credit_invoice": "Create credit invoice",
  "permission_mgmt_app_login": "Can login",
  "permission_mgmt_app_event_submenu_checkin_view": "Check-in overview",
  "permission_mgmt_app_event_scan_total_tickets_scanned_view": "See total scanned tickets on scanner screen",
  "permission_mgmt_app_event_checkin_swipe_checkout": "Check-in swipe unscan",
  "permission_mgmt_app_event_dashboard_tickets_sold_view": "Dashboard sold tickets overview",
  "permission_mgmt_app_ticket_detail_view": "Can see ticket details",
  "permission_mgmt_app_event_scan_ticket_details_view": "Show ticket details after scan",
  "permission_mgmt_app_prices_view": "Show prices",
  "permission_mgmt_app_event_overview_active_events": "View active events",
  "permission_mgmt_app_event_overview_past_events": "View past events",
  "permission_mgmt_app_menu_device_settings_view": "Menu device settings",
  "permission_mgmt_app_menu_search_in_all_orders_view": "Search in all orders",
  "permission_mgmt_app_menu_event_overview_view": "Menu event overview",
  "permission_mgmt_app_event_dashboard_tickets_scanned_view": "Dashboard scanned tickets overview",
  "permission_mgmt_app_event_submenu_dashboard_view": "Dashboard overview",
  "permission_mgmt_app_event_submenu_orders_view": "Order overview",
  "permission_mgmt_app_event_submenu_home_view": "Event overview",
  "permission_mgmt_app_event_checkin_swipe_checkin": "Check-in swipe checkin",
  "permission_mgmt_app_event_checkin_scan_btn_view": "Check-in show scan button",
  "permission_mgmt_app_ticket_detail_btn_checkout": "Ticket detail unscan",
  "permission_mgmt_app_ticket_detail_btn_checkin": "Ticket detail checkin",
  "permission_mgmt_app_event_checkin_product_settings_view": "Check-in specific product settings overview",
  "permission_mgmt_app_event_checkin_product_settings_update": "Can configure which products to scan",
  "permission_mgmt_app_ticket_sales_view": "May see ticket sales",
  "administration_invoice_number": "Invoice number",
  "permission_administration_overrule_fees_per_event_view": "Administration overrule fees per event view",
  "permission_administration_overrule_fees_per_event_edit": "Administration overrule fees per event edit",
  "administration_event_fees": "Overrule fee for event",
  "event_fees_retroactive": "Retroactive",
  "edit": "Edit",
  "company": "Company",
  "permission_mgmt_app_user_device_settings_view": "View user device settings",
  "permission_mgmt_app_user_device_settings_update": "Update user device settings",
  "pos_terms_conditions_url": "Terms & Conditions url",
  "cart_terms_conditions2": "When clicking the 'Continue' button you confirm that you read and agree with the <a href='{url}' target='_blank'>Terms & Conditions</a> & <a href='https://fairtix.io/en/privacy-policy' target='_blank'>Privacy Policy</a> of Fairtix and the <a href='{url2}' target='_blank'>Terms & Conditions</a> of {name}",
  "pos_invalid_url": "Invalid URL",
  "company_tickets_sold_out_notification": "Send almost sold out notification",
  "report_days_before_event": "{days} days before event",
  "report_event_day": "Event start date",
  "report_days_from_event": "{days} days from event",
  "report_free_tickets": "Of which free tickets",
  "company_layout_logo_url": "Logo URL",
  "pos_stock_pos": "POS",
  "pos_stock_product": "Product",
  "pos_stock_product_stock": "Product stock",
  "pos_stock_in_redis": "In redis",
  "pos_stock_pos_stock": "POS stock",
  "pos_stock_sold": "Sold",
  "email_confirmation": "Confirm email",
  "customer_form_email_confirmation_not_match": "Emails do not match",
  "report_in_worth_of": "In worth of",
  "order_already_paid": "Order already paid!",
  "customer_form_click_on_claim_button": "Click on the button Claim ticket to send the ticket to your e-mail address",
  "pos_no_language": "No language selected",
  "customer_information_specific_tickets": "Only ask this question when order contains specific tickets",
  "scan_terminal_choose_event_title": "Choose an event for which you want to start the Scan Terminal",
  "permission_scan_terminal_login": "Scan terminal login",
  "permission_scan_terminal_ticket_overview": "Scan terminal tickets overview",
  "no_events_to_show": "No events to show",
  "reports_scans_by_type": "Scans by type",
  "reports_tickets_scans": "Tickets scans",
  "reports_tickets_scans_hourly": "Hourly",
  "reports_tickets_scans_daily": "Daily",
  "reports_tickets_scans_weekly": "Weekly",
  "reports_tickets_scans_monthly": "Monthly",
  "reports_period": "Period",
  "reports_time_from": "Time from",
  "reports_time_to": "Time to",
  "reports_tickets_scanned": "Tickets scanned",
  "customer_information_field": "Field",
  "customer_information_order_ask": "Order question",
  "customer_information_order_mandatory": "Make mandatory",
  "customer_information_ticket_ask": "Question per ticket",
  "customer_information_ticket_mandatory": "Make mandatory",
  "customer_information_specific_question": "Question",
  "customer_information_specific_question_type": "Question type",
  "report_sold_out": "Sold out",
  "back": "Back",
  "my_company_allowed_events_days": "The user will have access to all events that are taking place on the days you select below",
  "day_mon": "Mon",
  "day_tue": "Tue",
  "day_wed": "Wed",
  "day_thu": "Thu",
  "day_fri": "Fri",
  "day_sat": "Sat",
  "day_sun": "Sun",
  "company_paynl_account_type": "Pay.nl account type",
  "company_payout_iban": "Payout IBAN number",
  "company_name_is_required": "Name is required",
  "company_domain_is_required": "Subdomain is required",
  "company_contact_is_required": "Person of contact is required",
  "pos_url_exists": "Some or all POS urls are used",
  "permission_event_show_minimum_age_checkbox": "Event show minimum age checkbox",
  "pos_age_confirmation": "I confirm that I and the other people I am ordering tickets for are at least {minimum_age} or older.",
  "event_age_confirmation_form": "Let customer check a checkbox to confirm that they are at least {age} years old",
  "ticket_template_duplicate" : "Duplicate template",
  "ticket_template_delete_entry" : "Are you sure you want to delete this ticket template?",
  "name_is_required" : "Name is required",
  "permission_ticket_template_duplicate": "Ticket template duplicate",
  "default_account_setup": "Default Account Setup",
  "backend_title_default_company_layout": "Default Company Layout",
  "backend_title_default_company_fees": "Default Fees",
  "backend_title_default_company_permissions": "Default Permissions",
  "backend_title_default_ticket_template": "Default ticket template",
  "default_company_layout": "Default Company Layout",
  "default_company_fees": "Default Fees",
  "default_company_permissions": "Default Permissions",
  "default_company_ticket_template": "Default ticket template",
  "permission_master_data_default_values_permissions_edit": "Default permissions edit",
  "permission_master_data_default_values_permissions_view": "Default permissions view",
  "permission_master_data_default_values_view": "Default values view",
  "permission_master_data_default_values_layout_edit": "Default company layout edit",
  "permission_master_data_default_values_layout_view": "Default company layout view",
  "permission_master_data_default_values_fees_edit": "Default company fees edit",
  "permission_master_data_default_values_fees_view": "Default company fees view",
  "permission_master_data_default_values_ticket_template_view": "Default ticket template view",
  "permission_master_data_default_values_ticket_template_edit": "Default ticket template edit",
  "field_is_required": "Field is required",
  "password_mismatch": "Password mismatch",
  "user_already_exists": "User is already exists",
  "signup_create_account": "Create account",
  "signup_enter_details": "Creating the account is completely free!",
  "signup_chamber_of_commerce": "Chamber of commerce number",
  "signup_iban": "IBAN",
  "signup_iban_holder_name": "IBAN account holder name",
  "signup_confirm_password": "Confirm password",
  "signup_terms": "I agree to the <a target='_blank' href='https://fairtix.io/en/terms-conditions'>Terms & Conditions</a> and declare that I am authorised to sign on behalf of the specified organisation",
  "signup_already_user": "Already have an account?",
  "signup_loading_creating_account": "Creating account...",
  "signup_loading_configuring_the_layout": "Configuring the layout...",
  "signup_loading_almost_done": "Almost done...",
  "signup_loading_go_to_dashboard": "Go to Dashboard as logged in user",
  "default_template_text": "Default template",
  "signup_step_2_title": "Complete the account",
  "signup_step_2_enter_details": "Provide the last details",
  "edit_ticket_template_err_no_jpg": "Chosen image must be JPG format",
  "edit_ticket_template_err_no_textbox": "There is a required minimum of one textbox",
  "error_background": "Image is mandatory",
  "event_description_location": "Where do you want to display the description",
  "manage_event_desc_location_top": "Top of the page",
  "manage_event_desc_location_bot": "Bottom of the page",
  "event_show_image_in_pos": "Show image on sales page",
  "product_scan_color": "Overrule scan color",
  "product_scan_color_explenation": "If a colour is set here, it will be displayed as soon as this ticket is successfully scanned",
  "product_remove_scan_color": "Delete scan color",
  "pos_no_products_and_pm_are_configured": "No products & payment methods are configured",
  "pos_no_products_are_configured": "No products are configured",
  "pos_no_pm_are_configured": "No payment methods are configured",
  "event_marketing_updated": "Event marketing updated",
  "permission_event_marketing_view": "Event marketing view",
  "permission_event_marketing_edit": "Event marketing edit",
  "event_marketing_gtm_id": "Google Tag Manager ID",
  "event_marketing_gtm_id_tooltip": "Once the GTM ID is filled in, GTM will be activated on the sales page. Empty this field to deactivate it again.",
  "edit_ticket_template_err_textbox_field": "All textbox fields are required",
  "discountcode_times_used": "Times used",
  "nav_campaigns": "Campaigns",
  "campaign_create": "Create campaign",
  "campaign_modal_create": "Create a new campaign",
  "campaign_name": "Campaign name",
  "campaign": "Campaign",
  "slug": "Slug",
  "event_day_selector": "Event/Day selector",
  "campaign_discount_rules": "Discount rules",
  "campaign_discount_type": "Discount type",
  "campaign_discount_value": "Discount value",
  "campaign_new_discount_rule": "New discount rule",
  "campaign_reference": "Reference",
  "campaign_when_does_this_discount_apply": "When does this discount apply",
  "campaign_timeframe_from": "Timeframe from",
  "campaign_timeframe_to": "Timeframe to",
  "reference_is_required": "Reference is required",
  "campaign_edit_rule": "Edit rule",
  "campaign_rule_set_product_price": "Product price",
  "campaign_rule_set_product_name": "Product name",
  "campaign_updated": "Campaign updated successfully",
  "slug_is_required": "Slug is required",
  "campaign_company_url": "Company campaign URL",
  "campaign_deleted": "Campaign deleted successfully",
  "cannot_delete_campaign": "Cannot delete campaign, it has associated orders",
  "campaign_times_used": "Times used",
  "campaign_total_revenue": "Total revenue",
  "slug_already_used": "Slug already in use",
  "copied_to_clipboard": "Copied to clipboard!",
  "order_overview_remove_discountcode_filter": "Remove discountcode filter",
  "discountcode_overview_show_orders": "Show orders",
  "discountcode_tickets_times_used": "Number of tickets",
  "report_age_avg": "Average age",
  "pos_countdown": "Show countdown",
  "pos_countdown_datetime": "Till when should the countdown be",
  "dashboard_modal_active_carts": "Active carts",
  "layout_countdown": "Countdown clock",
  "layout_countdown_card_top": "Top card clock",
  "layout_countdown_card_bottom": "Bottom card clock",
  "layout_countdown_card_text": "Text color numbers",
  "permission_campaigns_view": "Campaigns view",
  "permission_campaigns_create": "Campaigns add",
  "permission_campaigns_edit": "Campaigns edit",
  "permission_campaigns_delete": "Campaigns delete",
  "discountcode_allowed_events": "Allowed events",
  "discountcode_allowed_products": "Allowed products",
  "order_discountcode": "Discountcode",
  "nav_batches": "Batches",
  "batch_name": "Batch Name",
  "ticket_name": "Ticket Name",
  "ticket_price": "Ticket Price",
  "ticket_vat": "Ticket Vat",
  "tickets_count": "How many QR code do you want to make",
  "starts_at": "Starts at",
  "ends_at": "Ends at",
  "batch_events_or_days": "Choose the events or days on which the batch is valid",
  "edit_batch_title": "Edit Batch",
  "create_batch": "Create Batch",
  "batch_created": "Batch Created",
  "batch_updated": "Batch Updated",
  "batch_modal_create": "Create New Batch",
  "ticket_name_is_required": "Ticket name is mandatory",
  "ticket_price_is_required": "Ticket price is mandatory",
  "ticket_vat_is_required": "Ticket vat mandatory",
  "tickets_count_err": "The number of QR codes must be greater than 0 and less than 5000",
  "batch_generate": "Generate QR batch",
  "batch_download": "Download QR batch",
  "batch_generated": "Generation in progress, will take some time to be ready",
  "batch_already_generated": "Batch already generated",
  "order_overview_batch_ticket": "Batch ticket",
  "download": "Download",
  "qr_code": "QR code",
  "pos_qr_description": "This QR code is linking to the point of sale. This can be used on your flyer or for other marketing purposes",
  "campaign_highlight_discount": "Highlight the products with discounts",
  "campaign_highlight_discount_border_color": "Border color",
  "campaign_highlight_discount_background_color": "Background color",
  "campaign_hide_products": "I want to hide some specific products on the sales page",
  "campaign_when_hide_products": "Hide the products when:",
  "different": "Different",
  "event_vat_is_required": "VAT is required",
  "password_validation_8_chars": "Password length should be at least 8 characters",
  "password_validation_lowercase": "Password should have at least one lowercase letter",
  "password_validation_capital": "Password should have at least one capital letter",
  "password_validation_number": "Password should have at least one number",
  "signup_confirm_account": "Confirm your data",
  "signup_password_strength": "The password should be 8 characters and has at least 1 number, 1 letter, 1 uppercase and 1 special character",
  "discountcode_apply_type": "How do you want to calculate the discount:",
  "discountcode_apply_type_order": "Per order",
  "discountcode_apply_type_ticket": "Per ticket",
  "campaign_qr_description": "This QR-code is linked to the campaign. It can be used for a flyer or the QR-code can be spread in any other way",
  "password_validation_special_char": "Password should have at least one special characters",
  "export_order_timeslot": "Timeslot",
  "export_customer_dob": "Customer date of birth",
  "product_show_when_product_chosen": "Only show this product when another product is chosen",
  "event_products_selected": "product(s) selected",
  "event_products_no_selected": "no products selected",
  "product_show_hide_input_fields": "Show/Hide input fields",
  "product_min_max_buy_per_product": "Min & max buy per order",
  "product_more_items": "More items",
  "product_image_validate_size": "Image size should be less than 4MB",
  "product_image_validate_resolution": "Image resolution should be less than 120x120 px",
  "product_sell_product_sets": "Sell product in sets of",
  "master_data_auto_invoice_settings": "Automatic invoices settings",
  "nav_auto_invoice_settings": "Automatic invoices settings",
  "auto_invoice_settings_general_stop": "Is automatic invoicing active?",
  "changes_saved": "Changes saved!",
  "error_max_buy": "Max per order is mandatory",
  "error_min_buy": "Min per order is mandatory",
  "product_price_inclusive_vat": "Price (Incl. VAT)",
  "product_image_tooltip": "The image should be less than 4MB in size, has a maximum resolution of 120x120 PX, and is in either PNG or JPEG format",
  "product_send_additional_ticket": "Send out an additional ticket",
  "product_send_additional_ticket_ordered": "Send out an additional ticket when this product is ordered",
  "product_addition_already_set": "This ticket is already set as an additional ticket for {product}",
  "product_additional_ticket_description": "When this product is ordered, the products that you select below will automatically be added to the cart upon ordering",
  "event_product_send_email": "Send email when this product is ordered to",
  "email_is_invalid": "Please add a valid email address",
  "permission_product_ordered_email_confirmation": "Product ordered email confirmation",
  "guest_list_order_ticket_send_successfully": "Tickets have been send successfully",
  "guest_list_order_ticket_generated": "The tickets are being generated and send, please wait till this process has finished...",
  "pos_free_order_btn": "Continue to place the order",
  "company_invoice_overview": "Invoices",
  "company_invoice_overview_invoice": "Invoice",
  "company_invoice_overview_payout_summary": "Payout summary",
  "invoice_number": "Invoice number",
  "all_events": "All events",
  "company_invoice_downloads": "Downloads",
  "company_paynl_merchant_id": "Pay.nl M-code",
  "company_invoice_overview_total_payout": "Total payout",
  "company_invoice_overview_clearing_ref": "Clearing reference",
  "company_invoice_overview_time_period": "Time period",
  "permission_company_invoice_view": "Invoice overview view",
  "permission_company_invoice_can_download": "Can download invoices",
  "point_of_sale_modal_delete": "Delete point of sale",
  "point_of_sale_delete_confirmation": "Are you sure you want to delete this point of sale?",
  "point_of_sale_has_orders": "Point of sale has orders, you cannot delete it",
  "point_of_sale_has_been_deleted": "Point of sale has been deleted",
  "permission_event_point_of_sale_delete": "Point of sale delete",
  "campaign_overview_btn_link_generator": "Generate campaign link",
  "campaign_link_modal_title": "Generate campaign link",
  "campaign_campagne": "Campaign",
  "campaign_link_modal_link_type": "Where would you like to link to?",
  "campaign_link_modal_event_overview": "Event overview",
  "campaign_link_modal_specific_pos": "Specific event",
  "campaign_event": "Event",
  "campaign_pos": "Point of sale",
  "campaign_link_modal_link": "Link",
  "cart_incl_vat": "Incl. VAT",
  "fairtix_location_street": "Keizersveld 99",
  "fairtix_location_zip": "5803AP",
  "fairtix_location_city": "Venray",
  "fairtix_location_country": "The Netherlands",
  "fairtix_location_coc": "77888286",
  "fairtix_location_vat": "NL861186163B01",
  "shop_vat": "VAT",
  "extension_mailchimp": "Mailchimp",
  "extension_mailchimp_api_key": "API key",
  "extension_mailchimp_audience_id": "Audience key",
  "saved_successfully": "Saved succesfully",
  "extension_mailchimp_description": "Configure your mailchimp synchronisation. The email address, first name and last name (if available) will be pushed to Mailchimp in batches every 60 minutes. If you want to stop the synchronisation, just delete the API key.",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",
  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "may": "May",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "company_show_calendar": "Show calendar on event overview page",
  "company_calendar_sold_ratio": "Show sold ratio on calendar",
  "permission_extensions_overview_view": "Extensions overview view",
  "permission_extension_mailchimp": "Mailchimp",
  "permission_batch_overview_view": "Batch overview view",
  "permission_batch_edit": "Batch edit",
  "permission_batch_create": "Batch add",
  "permission_master_data_auto_invoice_settings_view": "Auto invoice settings view",
  "permission_master_data_auto_invoice_settings_edit": "Auto invoice settings edit",
  "cookie_banner_title": "Cookies",
  "cookie_banner_personalize": "Personalize your preferences",
  "cookie_banner_preference_local": "Information saved locally",
  "cookie_banner_preference_analytics": "Analytics",
  "cookie_banner_preference_marketing": "Marketing",
  "btn_accept_all": "Accept all",
  "btn_accept_selected": "Accept selected",
  "cookie_banner_change_preference": "Change cookie preferences",
  "cookie_banner_text": "Our website uses cookies to give you the best possible user experience. This allows us, for example, to remember what you have added to your shopping cart. In addition, we implement various other useful methods to improve your experience.",
  "order_overview_payment_link": "Payment link",
  "guest_list_payment_link": "Enlace de pago por correo electrónico",
  "guest_list_payment_link_send": "Payment link send",
  "venues_overview": "Venues overview",
  "venue_verified": "Is verified",
  "venue_name": "Venue name",
  "new_venue": "New venue",
  "venue_new_modal_title": "Create a new venue",
  "venue_modal_edit": "Edit venue",
  "venue_address": "Venue address",
  "venue_zip": "Venue zip",
  "venue_active": "Active",
  "venue_city": "Venue city",
  "venue_country": "Venue country",
  "venue_saved": "Venue saved!",
  "venue_deleted": "Venue deleted!",
  "permission_master_data_venues_overview": "Venues overview",
  "permission_venue_create": "Create venue",
  "permission_venue_delete": "Delete venue",
  "permission_venue_edit": "Edit venue",
  "permission_add_location_event_details": "Add venue in the event details",
  "event_location": "Location",
  "venue_is_already_used": "Venue is already used",
  "error_venue.name": "Venue name is required",
  "error_venue.address": "Venue address is required",
  "error_address": "Venue address is required",
  "error_venue.zip": "Venue zip is required",
  "error_zip": "Venue zip is required",
  "error_venue.city": "Venue city is required",
  "error_city": "Venue city is required",
  "error_venue.country_code": "Venue country is required",
  "error_country_code": "Venue country is required",
  "edit_ticket_template_reached_limit": "Image size should be less than 300KB",
  "company_links_overview": "Company Links",
  "company_master_name": "Company Master",
  "company_sub_name": "Company Sub",
  "location_id": "Location",
  "location_name": "Location",
  "company_link_new_modal_title": "Create a new Company link",
  "company_link_modal_edit": "Edit Company Link",
  "company_link_saved": "Company Link Saved!",
  "company_link_deleted": "Company Link deleted",
  "company_link_duplicate_entry": "Company Links Duplication",
  "company_link_master_sub_not_equal": "Company master must not be company sub",
  "error_company_master_id": "Company master is required",
  "error_company_sub_id": "Company sub is required",
  "permission_master_data_company_links_overview": "Company Links Overview",
  "permission_master_data_company_links_create": "Company Link Create",
  "permission_master_data_company_links_edit": "Company Link Edit",
  "permission_master_data_company_links_delete": "Company Link Delete",
  "company_link_unallowed_parent_child_entry": "Sub company cannot be a subordinate account for this company, as there is already a link where the company is a main account",
  "end_date_must_be_greater": "End date must be greater than start date",
  "product_limit_amount_to_maximum_tickets": "Limit amount to maximum of other tickets",
  "birth_date_must_be_past": "Birth date must be in the past",
  "product_scan_till_date_time": "Specific scan time",
  "url_cannot_spaces": "URL cannot contain spaces",
  "event_banner_tooltip": "This image will be shown in the pos overview on the desktop version",
  "event_banner_image": "Banner (1180x174 pixels) (<=1MB)",
  "manage_event_remove_banner": "Remove banner",
  "manage_event_banner_error_res": "Banner image resolution should be (1180x174 pixels)",
  "manage_event_banner_error_size": "Banner image size should be less than 1MB",
  "order_number_of_products": "Number of products",
  "user_app_login_duration": "Maximum login time in the app (in hours)",
  "edit_user_modal_app_login_duration_error": "Maximum login time in the app must be greater than 0",
  "download_tickets": "Download tickets",
  "order_status_ticket_merging": "Tickets are being merged",
  "invoice_overview_btn_generate_invoice": "Generate invoice",
  "invoice_overview_btn_generate_payout_summary": "Generate payout summary",
  "administration_invoice_payout_summary_generation": "Is allowed to generate invoice and payout summary",
  "invoice_overview_file_generated": "File generated",
  "ticket_template_qr_code_4cm": "QR code should be 4CM (152PX) positioned from the page borders",
  "ticket_template_qr_size": "The QR code should be no smaller than 100x100 and no larger than 225x225",
  "export_product_ticket_value": "Unique ticket code",
  "select": "Select...",
  "permission_administration_invoice_payout_summary_generation": "Invoice and payout summary generation",
  "ticket_lost_title": "Lost your tickets?",
  "ticket_lost_description": "Please fill in the fields below to get your tickets",
  "ticket_lost_no_orders": "We did not find your order(s), contact support-AtSign-fairtix.io for more information",
  "ticket_lost_search_tickets": "Search tickets",
  "ticket_lost_your_orders_description": "All tickets have been sent to your email address. Also check your spam folder.",
  "wrong_email": "Invalid email address",
  "wrong_date": "Invalid date",
  "company_order_thank_you_show_events": "Show events on the thank you page",
  "order_thank_you_btn_event_details": "Order now",
  "order_thank_you_upcoming_events": "Don't miss these events either!",
  "dashboard_events_ticket_sold": "sold",
  "dashboard_events_ticket_guest_list": "Number of guest list",
  "dashboard_events_yesterday": "Yesterday",
  "date_and_time": "Date and time",
  "start_date": "Start date",
  "end_date": "End date",
  "event_modal_create": "Create event",
  "lang_fr": "French",
  "lang_pt": "Portuguese",
  "pos_will_automatically_redirect": "We will automatically redirect you within {seconds} seconds to the active event overview",
  "pos_redirect_now": "Redirect now",
  "guest_list_event_name": "What event would you like to send guest list tickets for?",
  "guest_list_customer": "Who do you want to send the tickets to?",
  "guest_list_select_products": "How much do you want to send from which ticket?",
  "guest_list_send_to_email": "Send tickets to {email}",
  "guest_list_send_payment_request": "Send payment request to {email}",
  "guest_list_send_invitation_to_sign": "Send an invitation to sign tickets by name",
  "guest_list_select_payment": "What do you want to do with the payment?",
  "guest_list_select_payment_free": "No payment needing",
  "guest_list_select_payment_paid": "Cash has been paid",
  "guest_list_send": "Send",
  "guest_list_choose_tickets_to_send": "Choose tickets to send",
  "guest_list_ticket_type": "Ticket type",
  "guest_list_price": "Price",
  "guest_list_number": "Number",
  "pos_only_available_x": "Max {amount} available",
  "ticket_template_deleted": "Ticket template deleted successfully",
  "ticket_template_cannot_deleted": "Ticket template cannot be deleted",
  "permission_ticket_template_delete": "Ticket template delete",
  "order_overview_api_order": "API",
  "guest_list_remember_event": "Remember event for next entry",
  "order_export_generate_export": "Generate export",
  "order_export_export": "Export",
  "order_export_type": "What kind of export do you want to make?",
  "order_export_visitor_list": "Visitor list (for specific tickets)",
  "order_export_general": "General export",
  "order_export_which_event": "For which event?",
  "order_export_event": "Choose the event",
  "order_export_which_tickets": "For which tickets?",
  "order_export_select_tickets": "Select the tickets",
  "order_export_selected_tickets": "{count} ticket(s) selected",
  "order_export_which_email": "To which email address would you like to send the export?",
  "order_export_period": "What time period?",
  "order_export_which_fields": "What fields do you want in the export?",
  "order_export_success": "Successfully requested",
  "order_export_success_message": "Your export has been successfully requested and will be sent to {email}. This may take several minutes depending on the size of the file.",
  "order_export_all_tickets": "All tickets",
  "event_product_allow_for_multiple_events": "Allow for multiple events",
  "select_events": "Select events",
  "event_duplicate_product_allowed_events_note": "NOTE: You must manually link new events to this product after duplicating",
  "order_export_select_specific_event": "Select the event",
  "event_product_available_amount": "Available amount",
  "event_product_create_hint": "Once you have created the ticket, you can set more options if required.",
  "event_product_type_entrance": "Entrance",
  "event_product_type_tokens": "Tokens",
  "event_product_type_parking": "Parking",
  "event_product_type_cross-sell": "Cross-sell",
  "event_product_type_merchandise": "Merchandise",
  "event_product_type_donation": "Donation",
  "event_product_type_other": "Other",
  "event_product_create_success": "Product created successfully.",
  "pos_buy_your_tickets": "Buy your tickets now!",
  "pos_timeslot_choose_the_time": "Choose the time of your visit",
  "pos_personal_details": "Personal details",
  "pos_personal_details_complete_purchase": "Complete your purchase",
  "pos_payment": "Payment",
  "pos_payment_description": "Choose a payment method",
  "pos_order_success_title": "Your order: #{order_number} is placed successfully!",
  "event_product_persons": "Number of persons",
  "persons": "Persons",
  "pos_place_order_total": "Total (incl. VAT & €{total} booking costs)",
  "pos_place_order_got_a_code": "Got a code?",
  "read_more": "Read more",
  "read_less": "Read less",
  "layout_accent_color": "Accent color",
  "layout_description_color": "Description color",
  "layout_buttons_color": "Button color",
  "layout_button_text_color": "Button text color",
  "pos_important_information": "Important information",
  "shop_no_products_selected": "Select products to continue",
  "pos_buy_extra_products": "Buy extra products",
  "event_description_open_status": "Show description directly",
  "event_manage_event_description_show_tooltip": "If this option is enabled, the event description will be shown directly on the event page. If it is not enabled, people need to manually open it.",
  "event_products_create_first_ticket": "Create your first ticket!",
  "event_products_create_ticket_hint": "Every great event starts with one ticket-yours! Go on, give that button a little click and create your ticket.",
  "event_products_create_ticket_btn": "Create ticket",
  "event_products_create_pos": "Create your point of sale!",
  "event_products_create_pos_hint": "To be able to sell tickets you need a point of sale! Go on, give that button a click and create your point of sale.",
  "event_products_create_pos_btn": "Create point of sale",
  "event_selected_products": "product(s)",
  "event_products_mass_update": "Mass update product",
  "event_products_group_name": "Group name",
  "event_products_capacity": "Capacity",
  "event_product_mass_update_success": "Products updated successfully",
  "pos_use_discount_code": "Use discount code",
  "pos_fill_in_discount_code": "Fill in your discount code",
  "discount_code": "Discount code",
  "something_went_wrong": "Something went wrong",
  "btn_apply": "Apply"
}